import { connect } from 'react-redux';
import { createLoadingSelector } from 'redux/selectors';
import { deletePartner } from 'redux/services/api/unregister';
import UnregisterDelete from './unregister-delete';

const loadingSelector = createLoadingSelector(['UNREGISTER_DELETE']);

const mapStateToProps = (state) => ({
  success: state.api.unregister.deleteSuccess,
  error: state.api.unregister.deleteError,
  loading: loadingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  deletePartner: (personId) => dispatch(deletePartner(personId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnregisterDelete);